<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "ONT Optical Info" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the optical info of ont." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <!-- ONT光功率信息 -->
        <block-cntr :btitle="'optical Info'" style="height: 100%">
          <span style="font-weight: bold">Total entries: {{ total }}</span>
          <label style="float: right; display: flex">
            <span class="input-group-addon tablesearch-box">
              <i class="fa fa-search"></i>
            </span>
            <input
              type="search"
              v-model="searchInfo"
              class="form-control"
              placeholder="slot/pon"
              style="border-radius: 0px"
            />
          </label>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th
                  v-for="(value, key) in ontOpticalList.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: 350px">
              <tr v-for="row in ontOpticalInfoFilter" :key="row.ontid">
                <td v-for="(value, key) in row" :key="key" :title="value">
                  <div>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>

    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"

export default {
  components: {
    BlockCntr,
  },
  data() {
    return {
      ontOpticalList: "",
      total: "",
      searchInfo: "",
    }
  },
  created() {
    this.loadOntOpticalList()
  },
  methods: {
    loadOntOpticalList() {
      get("ontOpticalList")
        .then((res) => (this.ontOpticalList = res.data))
        .catch((err) => {
          this.ontOpticalList = en.ontOpticalList
        })
    },
  },
  computed: {
    ontOpticalInfoFilter() {
      var opticalInfo = []
      this.total = 0
      if (this.ontOpticalList.data !== undefined)
        this.ontOpticalList.data.forEach((element) => {
          if (
            this.searchInfo == "" ||
            (this.searchInfo.split("/")[0] == element.ontid.split("/")[0] &&
              this.searchInfo.split("/")[1] == element.ontid.split("/")[1])
          ) {
            opticalInfo.push(element)
            this.total += 1
          }
        })
      return opticalInfo
    },
  },
}
</script>